import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { SdkError } from "../errors";

export default async () => {
  const { waitForIdentityTimeout: timeoutMs } = clientConfigurationProvider();

  try {
    const { getAuthHeader } = await sdkInstanceProvider("identity");

    return await getAuthHeader({ timeoutMs, retries: 0 });
  } catch (e) {
    throw new SdkError(e);
  }
};
